import React, { useState } from "react";
import '../Tablero.scss'
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import markerIcon from '../../../../assets/icons/mapa.png'
import listaIcon from '../../../../assets/icons/lista.png'
const Filtros = (
    {
        unidades,
        trazo,
        setMostrarTrazos,
        mostrarTrazos,
        setCambiarVista,
        cambiarVista,
        clearAllFilters,
        setIsFiltersExpanded,
        isFiltersExpanded,
        zona,
        setZona,
        zonas,
        cliente,
        setSelectCliente,
        clientes,
        confirmadoNoConfirmado,
        setConfirmadoNoConfirmado,
        setTemaMapa,
        temaMapa,
        tipoServicio,
        setTipoServicio
    }
) => {
    // Opciones de filtros
    const [tipoServicios] = useState([
        { name: "AMBOS", code: 0 },
        { name: "SUMA", code: 1 },
        { name: "ALIADO", code: 2 }
    ]);
    const [tipoDeMapa] = useState([
        { name: "CLARO", code: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png' },
        { name: "OBSCURO", code: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png' },
    ]);


    const [confirmadosNoConfirmados] = useState([
        { name: "AMBOS", code: 0 },
        { name: "CONFIRMADOS", code: 1 },
        { name: "NO CONFIRMADOS", code: 2 }
    ]);
    
    return (
        <div className={`filters-container ${isFiltersExpanded ? 'expanded' : 'collapsed'}`}>
            <div className="filters-header">
                <h3 className="filters-title">
                    <i className="pi pi-filter"></i>
                    Filtros de Búsqueda
                </h3>
                <div className="filters-actions">
                    <div className="view-controls">
                        <div className="stats-info">
                            <span className="stat-item">
                                <i className="pi pi-map-marker"></i>
                                Unidades: {unidades.length}
                            </span>
                            <span className="stat-item">
                                <i className="pi pi-route"></i>
                                Rutas: {trazo.length}
                            </span>
                        </div>


                    </div>
                    <div className="view-controls">
                        <div className="stats-info">
                            <span className="stat-item">

                                Mostrar Trazos: <Checkbox inputId="ingredient1" name="pizza" value="Cheese" onChange={(e) => { setMostrarTrazos(e.checked) }} checked={mostrarTrazos} />
                            </span>
                        </div>


                    </div>
                    <div className="view-controls">
                        <Button
                            onClick={() => setCambiarVista(!cambiarVista)}
                            className={`btn-view-toggle ${cambiarVista ? 'timeline-view' : 'map-view'}`}
                            title={cambiarVista ? "Ver mapa" : "Ver línea de tiempo"}
                        >
                            <img
                                width={20}
                                src={!cambiarVista ? listaIcon : markerIcon}
                                alt={!cambiarVista ? "Vista de lista" : "Vista de mapa"}
                            />
                            <span>{!cambiarVista ? "Lista" : "Mapa"}</span>
                        </Button>
                    </div>
                    <button
                        className="btn-clear-filters"
                        onClick={clearAllFilters}
                        title="Limpiar todos los filtros"
                    >
                        <i className="pi pi-times"></i>
                        Limpiar
                    </button>
                    <button
                        className="btn-toggle-filters"
                        onClick={() => setIsFiltersExpanded(!isFiltersExpanded)}
                        title={isFiltersExpanded ? "Contraer filtros" : "Expandir filtros"}
                    >
                        <i className={`pi ${isFiltersExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`}></i>
                    </button>
                </div>
            </div>

            {isFiltersExpanded && (
                <div className="filters-grid">
                    <div className="filter-item">
                        <label className="filter-label">Zona</label>
                        <MultiSelect
                            value={zona}
                            onChange={(e) => setZona(e.value)}
                            options={zonas}
                            optionLabel="name"
                            filter
                            placeholder="Seleccionar zona(s)"
                            maxSelectedLabels={3}
                            className="multi-select"
                            showClear
                        />
                    </div>

                    <div className="filter-item">
                        <label className="filter-label">Empresas</label>
                        <MultiSelect
                            value={cliente}
                            onChange={(e) => setSelectCliente(e.value)}
                            options={clientes}
                            optionLabel="name"
                            filter
                            placeholder="Seleccionar empresa(s)"
                            maxSelectedLabels={3}
                            className="multi-select"
                            showClear
                        />
                    </div>

                    <div className="filter-item">
                        <label className="filter-label">Tipo de Servicio</label>
                        <Dropdown
                            placeholder="Seleccionar tipo"
                            className="multi-select"
                            obligatory={false}
                            options={tipoServicios}
                            style={{ height: '38px', alignItems: 'center' }}
                            optionLabel="name"
                            value={tipoServicio}
                            onChange={(e) => setTipoServicio(e.value)}
                            showClear
                        />
                    </div>

                    <div className="filter-item">
                        <label className="filter-label">Confirmación</label>
                        <Dropdown
                            placeholder="Estado de confirmación"
                            className="multi-select"
                            obligatory={false}
                            style={{ height: '38px', alignItems: 'center' }}
                            options={confirmadosNoConfirmados}
                            optionLabel="name"
                            value={confirmadoNoConfirmado}
                            onChange={(e) => setConfirmadoNoConfirmado(e.value)}
                            showClear
                        />
                    </div>
                    <div className="filter-item">
                        <label className="filter-label">Tema de mapa</label>
                        <Dropdown
                            placeholder="Seleccionar tema"
                            className="multi-select"
                            obligatory={false}
                            style={{ height: '38px', alignItems: 'center' }}
                            options={tipoDeMapa}
                            optionLabel="name"
                            value={temaMapa}
                            onChange={(e) => setTemaMapa(e.value)}
                        />
                    </div>


                </div>
            )}
        </div>
    )
}
export default Filtros